import React from "react";
import { useSelector } from "react-redux";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import CircularProgress from "@mui/material/CircularProgress";
import MUICashTableHeader from "./Headers/CashTableHeader";
import CashGameTableBody from "./Bodys/CashGameTableBody";
import { RootState, GameData, GamelistModalDetails } from "types";


interface PrivateCashTableProps {
  setModalDets: (dets: GamelistModalDetails) => void;
  setGameData: (data: GameData) => void;
}

const PrivateCashTable = (props: PrivateCashTableProps) => {
  const privCashList = useSelector((state: RootState) => state.games.privateCashList);

  if (!privCashList) {
    return <CircularProgress />;
  }
  if (Object.keys(privCashList).length) {
    return (
      <TableContainer component={Paper} elevation={10}>
        <Table
          className="tablelist"
          aria-label="private cash table"
          id="PrivateGameList"
        >
          <MUICashTableHeader />
          <CashGameTableBody data={privCashList} {...props} />
        </Table>
      </TableContainer>
    );
  }
  return <div>No Private Cash Games Found </div>;
};

export default PrivateCashTable;
